module.exports = __webpack_public_path__ + "static/before-70b4231eec13c09f3e6890c07e4b8d7c.png";